define(['jquery'], function ($) {

    /* This multiselect implementation only supports one multiselect per page. If need arrises, update this code to support more. */

    var multiselectSelector = '.multiselect';
    var isClosedClass = 'multiselect--isclosed';
    var isSelectedClass = 'multiselect--isselected';
    var hasSelectionsClass = 'multiselect--hasselections';
    var buttonSelector = '.multiselect--button';
    var closeDialogSelector = '.js-multiselect-close';
    var groupSelectLabelClass = 'multiselect--groupselectlabel';
    var labelClass = 'multiselect--label';
    var labelSelector = '.' + labelClass;
    var labelTextClass = 'multiselect--labeltext';
    var labelTextSelector = '.' + labelTextClass;
    var checkboxClass = 'multiselect--checkbox';
    var checkboxSelector = '.' + checkboxClass;
    var allOptionClass = 'js-multiselect-alloption';
    var allOptionSelector = '.' + allOptionClass;
    var multiselectCallbackOnChange;

    var ESC_keycode = 27;
    var TAB_keycode = 9;
    var UP_keycode = 38;
    var DOWN_keycode = 40;
    var allSelectedText = "Alla";

    var setTrap = function () {
        if (!multiselect.clickTrap) {
            multiselect.clickTrap = clickTrap;
            $("body").on("click", clickTrap);
        }
        if (!multiselect.keyTrap) {
            multiselect.keyTrap = keyTrap;
            $("body").on("keydown", keyTrap);
        }
        if (!multiselect.focusTrap) {
            multiselect.focusTrap = focusTrap;
            $("body").on("focusin", focusTrap);
        }
    }

    var unsetTrap = function () {
        if (multiselect.clickTrap) {
            multiselect.clickTrap = null;
            $("body").off("click", clickTrap);
        }
        if (multiselect.keyTrap) {
            multiselect.keyTrap = null;
            $("body").off("keydown", keyTrap);
        }
        if (multiselect.focusTrap) {
            multiselect.focusTrap = null;
            $("body").off("focusin", focusTrap);
        }
    }

    //click outside of multiselect should close multiselect.
    var clickTrap = function (event) {
        var $target = $(event.target);
        var unset = true;

        var $openMultiselect = $(multiselectSelector + ":not(." + isClosedClass + ")");
        if ($openMultiselect.length > 0) {
            //check if we are inside open multiselect
            var parentMultiselect = $target.closest(multiselectSelector);
            if (parentMultiselect.length && !parentMultiselect.hasClass(isClosedClass)) {
                unset = false;
            } else {
                multiselect.close($openMultiselect);
            }
        }

        if (unset) {
            unsetTrap();
        }
    }

    //pressing ESC should close multiselect
    //arrow up/down should work as tab/shift+tab
    //tabbing past last checkbox should focus on first checkbox
    //shift+tab from button should select last checkbox
    var keyTrap = function (event) {
        var unset = false;
        var $openMultiselect = $(multiselectSelector + ":not(." + isClosedClass + ")");
        if ($openMultiselect.length > 0) {
            var keyHandled = true;
            switch (event.keyCode) {
                case ESC_keycode:
                    multiselect.close($openMultiselect, true);
                    unset = true;
                    break;
                case TAB_keycode:
                    if (event.shiftKey) {
                        movePrevious($openMultiselect);
                    } else {
                        moveNext($openMultiselect);
                    }
                    break;
                case UP_keycode:
                    movePrevious($openMultiselect);
                    break;
                case DOWN_keycode:
                    moveNext($openMultiselect);
                    break;
                default:
                    keyHandled = false;
            }
            if (keyHandled) {
                event.preventDefault();
            }            
        }

        if (unset) {
            unsetTrap();
        }
    }

    var moveNext = function ($openMultiselect) {
        var $focusedElement = $openMultiselect.find(":focus");
        var $visibleFocusables = $openMultiselect.find(checkboxSelector + ":visible , " + closeDialogSelector);

        var $firstFocusable = $visibleFocusables.first();
        if ($focusedElement.is(buttonSelector)) {
            $firstFocusable.focus();
            return;
        }
        if ($focusedElement.is(closeDialogSelector)) {
            $firstFocusable.focus();
            return;
        }
        var indexOfFocused = $visibleFocusables.index($focusedElement);
        var nextElement = $visibleFocusables.get(indexOfFocused + 1);
        $(nextElement).focus();
        return;
    }

    var movePrevious = function ($openMultiselect) {
        var $focusedElement = $openMultiselect.find(":focus");
        var $visibleFocusables = $openMultiselect.find(checkboxSelector + ":visible , " + closeDialogSelector);

        var $lastFocusableElement = $visibleFocusables.last();
        if ($focusedElement.is(buttonSelector)) {
            $lastFocusableElement.focus();
            return;
        }

        var $firstFocusable = $visibleFocusables.first();
        if ($focusedElement.is($firstFocusable)) {
            $openMultiselect.find(buttonSelector).focus();
            return;
        }
        var indexOfFocused = $visibleFocusables.index($focusedElement);
        var previousElement = $visibleFocusables.get(indexOfFocused - 1);
        $(previousElement).focus();
        return;
    }


    //multiselect losing focus should close multiselect
    var focusTrap = function (event) {
        var $target = $(event.target);
        var unset = true;        

        var $openMultiselect = $(multiselectSelector + ":not(." + isClosedClass + ")");

        if ($openMultiselect.length > 0) {
            //check if target is inside multiselect
            var isInsideOpenMultiselect = $target.closest($openMultiselect).length > 0;
            if (isInsideOpenMultiselect) {
                unset = false;
            } else {
                multiselect.close($openMultiselect);
            } 
        }

        if (unset) {
            unsetTrap();
        }
    }

    var hasSelectionGroups = function ($baseElement) {
        return $baseElement.attr("data-groupselect") === "true";
    }

    var handleCheckboxChange = function (event) {
        var $checkbox = $(event.target);
        updateLabelStatus($checkbox);

        var $baseElement = $checkbox.closest(multiselectSelector);
        if (hasSelectionGroups($baseElement)) {
            handleGroupSelectStatus($checkbox);
        }

        updateButtonText($baseElement);
    }

    var updateLabelStatus = function ($checkbox) {
        var $label = $checkbox.closest(labelSelector);
        $label.toggleClass(isSelectedClass, $checkbox.prop("checked"));
    }

    var updateButtonText = function ($baseElement) {
        var $selectedOptionsLabel = $baseElement.find(".multiselect--selectedoptions");
        var $additionalSelectionsCountLabel = $baseElement.find(".multiselect--additionalselectionscount");
        var $caption = $baseElement.find(".multiselect--caption");
        var $selectedOptionsWrapper = $baseElement.find(".multiselect--selectedoptionswrapper");

        var selectedNames = getSelectedNames($baseElement);
        var hasSelections = selectedNames.length > 0;
        $baseElement.toggleClass(hasSelectionsClass, hasSelections);

        if (hasSelections) {
            $selectedOptionsLabel.attr("aria-label", selectedNames.join(", "));
        } else {
            // TODO: hide label count with addClass visuallyhidden
            $selectedOptionsLabel.text(allSelectedText);
            $selectedOptionsLabel.attr("aria-label", allSelectedText);
        }

        //Note: selectedNames could have been correctly reduced if spliced in hasSelections.
        var selectedAddonText = selectedNames.length > 1 ? ' valda' : ' vald';
        $additionalSelectionsCountLabel.text(selectedNames.length + selectedAddonText);
        $additionalSelectionsCountLabel.toggle(!!selectedNames.length);
    }

    var getSelectedNames = function ($baseElement) {
        var name = $baseElement.attr("data-name");
        var names = [];

        var populateNamesWithAllCheckedInSection = function ($section) {
            var $allChecked = $section.find("[name=" + name + "]:checked").not(allOptionSelector);
            $allChecked.each(function (index) {
                var $checked = $(this);
                var text = $checked.closest(labelSelector).find(labelTextSelector).text();
                names.push(text);
            });
        }

        if (!hasSelectionGroups($baseElement)) {
            populateNamesWithAllCheckedInSection($baseElement);
        } else {
            var $fieldsets = $baseElement.find("fieldset");
            $fieldsets.each(function () {
                var $fieldset = $(this);
                //find all checkboxes under this fieldset, but ignore the All option
                var $groupSelectCheckbox = $fieldset.find("." + groupSelectLabelClass + " " + checkboxSelector).not(allOptionSelector);
                if ($groupSelectCheckbox.prop("checked")) {
                    var text = $groupSelectCheckbox.closest(labelSelector).find(labelTextSelector).text();
                    names.push(text);
                } else {
                    populateNamesWithAllCheckedInSection($fieldset);
                }
            })
        }

        return names;
    }

    var setupGroupSelects = function ($baseElement) {
        var baseName = $baseElement.attr("data-name");
        var $fieldsets = $baseElement.find("fieldset");
        $fieldsets.each(function (index) {
            var $fieldset = $(this);            
            var fieldsetName = $fieldset.attr("name");
            var $legend = $fieldset.children("legend").first();
            var groupCheckboxId = baseName + "_" + fieldsetName;
            var $controlledCheckboxes = $fieldset.find(checkboxSelector);
            var controlledCheckboxIds = $controlledCheckboxes.map(function () { return this.id; }).get();

            // special class for the select all option, because we have special behavior on it like it does not count as a selected option in the status text, and special event handlers
            var isSelectAllOptionClass = $controlledCheckboxes.hasClass(allOptionClass) ? " " + allOptionClass : "";

            var $groupSelectElements =
                $('<label for="' + groupCheckboxId + '" class="' + labelClass + ' ' + groupSelectLabelClass + '">' +
                    '<span><input type="checkbox" id="' + groupCheckboxId + '" aria-controls="' + controlledCheckboxIds.join(" ") + '" class="' + checkboxClass + isSelectAllOptionClass + '"></span>' +
                    '<span class="' + labelTextClass + '">' + $legend.text() + '</span>' +
                    '</label >');
            $groupSelectElements.insertAfter($legend);

            //handle groupselect change
            $groupSelectElements.find("#" + groupCheckboxId).change(function (event) {
                var $groupCheckbox = $(this);

                // check all child checkboxes if group checkbox is checked. Uncheck childs if group checkbox is unchecked
                $controlledCheckboxes.prop("checked", $groupCheckbox.prop("checked"));

                updateLabelStatus($groupCheckbox);
                $controlledCheckboxes.each(function () { updateLabelStatus($(this)) });

                updateButtonText($baseElement);
            });

            //if all child checkboxes are checked, then check the group checkbox
            var allChecked = $fieldset.find('input[type="checkbox"]:checked').length === $controlledCheckboxes.length;
            if (allChecked) {
                $groupSelectElements.find("#" + groupCheckboxId).each(function () {
                    var $groupCheckbox = $(this);
                    $groupCheckbox.prop("checked", "checked");
                })
            }

            //handle single checkbox in group
            if ($controlledCheckboxes.length === 1) {
                $controlledCheckboxes.closest(labelSelector).hide();
            }

            $legend.addClass("visuallyhidden");
        })

        $baseElement.addClass("multiselect--hasgroupselects");
    }

    // updates parent checkbox status based on all child checkboxes
    var handleGroupSelectStatus = function ($checkbox) {
        var $groupSelectCheckbox = $checkbox.closest("fieldset").find("." + groupSelectLabelClass + " " + checkboxSelector);
        var $controlledCheckboxes = $checkbox.closest("fieldset").find(labelSelector + ":not(." + groupSelectLabelClass + ") " + checkboxSelector);

        var anyUncheckedCheckbox = $controlledCheckboxes.is(":not(:checked)");
        var allControlledCheckboxesAreChecked = !anyUncheckedCheckbox;

        $groupSelectCheckbox.prop("checked", allControlledCheckboxesAreChecked);

        updateLabelStatus($groupSelectCheckbox);
    }

    var setupAllOptionLogic = function($baseElement) {
        // find the elements we need
        var $allCheckbox = $baseElement.find(allOptionSelector);
        var $allCheckboxes = $baseElement.find(checkboxSelector).not(allOptionSelector);

        // if all option is checked, de-select all other options
        $allCheckbox.click(function (event) {
            if ($allCheckbox.is(":checked")) {
                $allCheckboxes.prop("checked", false);
                $allCheckboxes.each(function () { updateLabelStatus($(this)); });
                updateButtonText($baseElement);
            }
        });

        // if any other option than all option is checked, uncheck all option
        $allCheckboxes.click(function (event) {
            if ($(event.target).is(":checked")) {
                $allCheckbox.prop("checked", false);
                updateLabelStatus($allCheckbox);
            }
        })
    }

    var multiselect = {

        keyTrap: null,
        clickTrap: null,
        focusTrap: null,

        init: function (callbackOnChange) {
            var $elements = $(multiselectSelector);
            multiselectCallbackOnChange = callbackOnChange;
            $elements.each(function (index, element) {
                multiselect.setup($(element))
            });
        },
        refreshMultiSelects: function () {

            var $multiSelects = $(multiselectSelector);
            $multiSelects.each(function (index) {
                updateButtonText($(this));
            });

            var $checkboxes = $(checkboxSelector);
            $checkboxes.each(function (index) {
                handleGroupSelectStatus($(this))
                updateLabelStatus($(this));
            });
        },
        setup: function ($baseElement) {
            //The default when javascript is disabled is that the button is nonfunctional/disabled and the options are always visible.
            //when initialising we therefore first hide/close the options and 
            //add aria-attributes that tells us that the button opens a related dialog

            //the main button to open and close the dialog
            var $button = $baseElement.find(buttonSelector).first(); 
            //the "close" button inside at the bottom of the dialog window
            var $dialogCloseButton = $baseElement.find(closeDialogSelector).first();
            $baseElement.addClass(isClosedClass);
            $button.attr("aria-expanded", "false");

            var dialogId = $button.attr("data-dialogid");
            var $dialog = $("#" + dialogId);

            $dialog.attr("role", "dialog");
            $button.click(multiselect.handleButtonClick);
            $dialogCloseButton.click(multiselect.handleButtonClick);

            var $checkboxesBeforeGroupSelects = $baseElement.find(checkboxSelector);
            $checkboxesBeforeGroupSelects.change(handleCheckboxChange);
            
            if (hasSelectionGroups($baseElement)) {                
                setupGroupSelects($baseElement);
            }

            updateButtonText($baseElement);

            // must run after any elements have been inserted, like setupGroupSelects
            setupAllOptionLogic($baseElement);

            $baseElement.addClass("multiselect--isinitialized");
            $baseElement.change(function () {
                multiselectCallbackOnChange();
            });

        },

        handleButtonClick: function (event) {
            var $baseElement = $(event.target).closest(multiselectSelector);

            var $button = $baseElement.find(buttonSelector).first();
            var dialogId = $button.attr("data-dialogid");
            var $dialog = $("#" + dialogId);

            if ($baseElement.hasClass(isClosedClass)) {
                multiselect.open($baseElement, $dialog, $button);                
            } else {
                multiselect.close($baseElement, true);                
            }
        },

        open: function ($baseElement, $dialog, $button) {
            $baseElement.removeClass(isClosedClass);
            $button.attr("aria-expanded", "true");

            //focus first
            $dialog.find(checkboxSelector).first().focus();

            setTrap();
        },

        close: function ($baseElement, shouldFocusButton) {
            var $button = $baseElement.find(buttonSelector).first();

            $baseElement.addClass(isClosedClass);
            $button.attr("aria-expanded", "false");

            if (shouldFocusButton) {
                //focus button
                $button.focus();
            }
        },
        getSelectedValues: function () {
            return $(checkboxSelector + ":checked").map(function () { return $(this).val(); }).get();
        },

        setSelected: function (values) {
            if (values === 'undefined')
                return;

            // unselect all
            $(checkboxSelector).each(function (index, element) {
                element.checked = false;
            });

            // set selected
            $(checkboxSelector).each(function (index, element) {
                $(values).each(function (i, val) {
                    if (element.getAttribute('value') === val)
                        element.checked = true;
                });
            });

            // update texts on button
            this.refreshMultiSelects();
        }
    }
    return multiselect;

});